<template>
    <router-link
        tag="li"
        :to="to"
        active-class=""
        exact-active-class="active"
    ><a>
        <i :class="`icon mdi mdi-${icon}`"></i>
        {{title}}
        <span :class="countClass">{{count}}</span>
    </a></router-link>
</template>

<script>
    export default {
        computed: {
            countClass: vm => ({
                badge: true,
                [`badge-${vm.countColor}`]: !!vm.countColor,
                'float-right': true,
            }),
        },
    };
</script>
